'use client';
import { useAuth } from '@practium/features/auth';
import { mockDossierDocuments, mockHeroTopics } from '../services';
import { useFloraAI } from '../hooks/useFloraAI';
import { FloraInputArea } from '../components/FloraInputArea/FloraInputArea';
import { FloraDossierSection } from '../components/FloraDossierSection/FloraDossierSection';
import { FloraHeroSection } from '../components/FloraHeroSection/FloraHeroSection';
import { FloraLibraryModal } from '../components/FloraLibraryModal/FloraLibraryModal';
import styles from './FloraAIPage.module.css';

const FLORA_SLEEPING_SRC = '/flora-page/flora-eyes-closed.png';

export const FloraAIPage = () => {
	const { user } = useAuth();
	const {
		handlers,
		isLibraryOpen,
		activeLibraryFilterId,
		selectedLibraryIds,
		selectedLibraryCount,
		libraryFilters,
		libraryDocuments,
	} = useFloraAI({
		userRole: user?.role,
	});
	const firstDocumentName = mockDossierDocuments[0]?.name ?? '';

	return (
		<div className={styles.page}>
			<FloraDossierSection
				documents={mockDossierDocuments}
				onNewConversation={handlers.handleViewChats}
				onOpenLibrary={handlers.handleOpenLibrary}
				onAddDocument={handlers.handleOpenLibrary}
			/>

			<div className={styles.center}>
				<div className={styles.heroWrap}>
					<FloraHeroSection
						firstDocumentName={firstDocumentName}
						topics={mockHeroTopics}
						onTopicClick={(topic) => handlers.handleSuggestionClick(topic.label)}
					/>
				</div>

				<div className={styles.inputBlock}>
					<FloraInputArea
						onSend={handlers.handleSendMessage}
						onAttach={handlers.handleAttach}
						onDeepThink={handlers.handleDeepThink}
					/>
					<p className={styles.disclaimer}>
						A Flora pode cometer erros. Por isso, é bom checar as respostas.
					</p>
				</div>
			</div>

			<img
				className={styles.sleepingFlora}
				src={FLORA_SLEEPING_SRC}
				alt=""
				aria-hidden="true"
			/>

			<FloraLibraryModal
				isOpen={isLibraryOpen}
				onClose={handlers.handleCloseLibrary}
				filters={libraryFilters}
				activeFilterId={activeLibraryFilterId}
				onFilterChange={handlers.handleLibraryFilterChange}
				documents={libraryDocuments}
				onToggleDossier={handlers.handleToggleLibraryDocument}
				selectedIds={selectedLibraryIds}
				onToggleSelect={handlers.handleToggleLibrarySelection}
				onSearch={handlers.handleLibrarySearch}
				onUpload={handlers.handleLibraryUpload}
				selectedCount={selectedLibraryCount}
				onRemoveSelected={handlers.handleLibraryRemoveSelected}
				onAddSelected={handlers.handleLibraryAddSelected}
			/>
		</div>
	);
};
